(function () {
  var posthogStarted = false;
  var commerceTrackingStarted = false;
  var pdpCtaImpressionTrackingStarted = false;
  var pendingPdpAddAttempt = null;
  var pendingPdpAddAttemptTimeout = null;
  var currentPostHogSessionId = null;
  var PDP_EVENT_CONTRACT = "pdp_commerce_v1";
  var dwkPageViewId = createEventId();

  function startPostHog() {
    if (posthogStarted) return;
    posthogStarted = true;
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Sn Cn init Hn Un Gn Yi zn Kn qn capture Vn kn calculateEventProperties es register register_once register_for_session unregister unregister_for_session os Bn ss getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync ls identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset us shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty rs Xn createPersonProfile setInternalOrTestUser ns $n vs opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Jn debug tr At getPageViewId captureTraceFeedback captureTraceMetric Ln".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init("phc_AEiMLjkwdzsp7BWFj9DwJazr7nRaoKLG9NK7i9q76BQJ", {
      api_host: "https://us.i.posthog.com",
      defaults: "2026-05-30",
      person_profiles: "identified_only",
      advanced_feature_flags_dedup_per_session: true
    });
    if (typeof posthog.onSessionId === "function") {
      posthog.onSessionId(function (sessionId) {
        currentPostHogSessionId = sessionId || null;
        if (currentPostHogSessionId && typeof posthog.register_for_session === "function") {
          posthog.register_for_session({dwk_session_id: currentPostHogSessionId});
        }
      });
    }
  }

  function syncPostHogConsent() {
    var analyticsAllowed =
      window.Shopify &&
      Shopify.customerPrivacy &&
      Shopify.customerPrivacy.analyticsProcessingAllowed();

    if (analyticsAllowed) {
      var wasAlreadyStarted = posthogStarted;
      startPostHog();
      if (
        wasAlreadyStarted &&
        window.posthog &&
        posthog.has_opted_out_capturing &&
        posthog.has_opted_out_capturing()
      ) {
        posthog.opt_in_capturing();
      }
      startPdpCtaImpressionTracking();
    } else if (window.posthog && posthog.opt_out_capturing) {
      posthog.opt_out_capturing();
    }
  }

  function isProductPage() {
    return /^\/products\//.test(window.location.pathname);
  }

  function productContext(target) {
    var component = target && target.closest
      ? target.closest("product-form-component")
      : null;
    if (!component) {
      component = document.querySelector(
        "main product-form-component:not(.quick-add__product-form-component), product-form-component:not(.quick-add__product-form-component)"
      );
    }

    var variantInput = component && component.querySelector('[name="id"]');
    var pathParts = window.location.pathname.split("/").filter(Boolean);

    return {
      product_id: component && component.dataset ? component.dataset.productId || null : null,
      product_handle: pathParts[0] === "products" ? pathParts[1] || null : null,
      variant_id: variantInput ? variantInput.value || null : null
    };
  }

  function publishCustomerEvent(name, data) {
    if (
      !window.Shopify ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== "function"
    ) return;

    Shopify.analytics.publish(name, data);
  }

  function analyticsAllowed() {
    return Boolean(
      window.Shopify &&
      Shopify.customerPrivacy &&
      Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "dwk-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
  }

  function selectedOfferContext() {
    var selectedOffer = document.querySelector(
      "pdp-bundle-selector [data-variant-id]:checked"
    );

    return {
      offer_label: selectedOffer && selectedOffer.dataset
        ? selectedOffer.dataset.offerLabel || null
        : null,
      offer_product_id: selectedOffer && selectedOffer.dataset
        ? selectedOffer.dataset.productId || null
        : null,
      offer_variant_id: selectedOffer && selectedOffer.dataset
        ? selectedOffer.dataset.variantId || null
        : null,
      offer_price_cents: selectedOffer && selectedOffer.dataset
        ? Number(selectedOffer.dataset.priceCents) || null
        : null
    };
  }

  function deviceClass() {
    if (window.innerWidth < 768) return "mobile";
    if (window.innerWidth < 1024) return "tablet";
    return "desktop";
  }

  function themeContext() {
    var theme = window.Shopify && Shopify.theme || {};
    return {
      theme_id: theme.id || null,
      theme_name: theme.name || null,
      theme_role: theme.role || null
    };
  }

  function capturePdpCommerceEvent(name, target, data) {
    if (!isProductPage() || !analyticsAllowed()) return null;

    startPostHog();
    if (!window.posthog || typeof posthog.capture !== "function") return null;

    var eventId = data && data.event_id || createEventId();
    var sessionId = currentPostHogSessionId || (
      typeof posthog.get_session_id === "function" ? posthog.get_session_id() : null
    );
    var pageViewId = typeof posthog.getPageViewId === "function"
      ? posthog.getPageViewId()
      : null;

    posthog.capture(
      name,
      Object.assign(
        {
          event_contract: PDP_EVENT_CONTRACT,
          event_id: eventId,
          tracking_source: "shopify_theme",
          dwk_session_id: sessionId || null,
          dwk_page_view_id: pageViewId || dwkPageViewId,
          device_class: deviceClass(),
          viewport_width: window.innerWidth || null,
          viewport_height: window.innerHeight || null
        },
        themeContext(),
        productContext(target),
        selectedOfferContext(),
        data || {}
      )
    );

    return eventId;
  }

  function clearPendingPdpAddAttempt() {
    window.clearTimeout(pendingPdpAddAttemptTimeout);
    pendingPdpAddAttemptTimeout = null;
    pendingPdpAddAttempt = null;
  }

  function rememberPdpAddAttempt(target, ctaLocation) {
    clearPendingPdpAddAttempt();

    var attemptId = createEventId();
    var context = productContext(target);
    pendingPdpAddAttempt = {
      attempt_id: attemptId,
      cta_location: ctaLocation,
      variant_id: context.variant_id,
      quantity: 1,
      started_at_ms: Date.now()
    };

    capturePdpCommerceEvent("pdp_cta_click", target, pendingPdpAddAttempt);
    capturePdpCommerceEvent("pdp_add_attempt", target, pendingPdpAddAttempt);
    pendingPdpAddAttemptTimeout = window.setTimeout(clearPendingPdpAddAttempt, 30000);
  }

  function finishPdpAddAttempt(outcome, target, data) {
    if (!pendingPdpAddAttempt) return;

    var eventData = Object.assign({}, pendingPdpAddAttempt, data || {});
    eventData.request_duration_ms = Math.max(0, Date.now() - pendingPdpAddAttempt.started_at_ms);
    capturePdpCommerceEvent(
      outcome === "success" ? "pdp_add_success" : "pdp_add_failure",
      target,
      eventData
    );
    clearPendingPdpAddAttempt();
  }

  function startPdpCtaImpressionTracking() {
    if (
      pdpCtaImpressionTrackingStarted ||
      !isProductPage() ||
      !analyticsAllowed() ||
      typeof IntersectionObserver !== "function"
    ) return;
    pdpCtaImpressionTrackingStarted = true;

    var observed = new WeakSet();
    var timers = new WeakMap();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var target = entry.target;
        var isHidden = target.hidden || target.closest("[hidden]");
        var isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5 && !isHidden;

        if (!isVisible) {
          window.clearTimeout(timers.get(target));
          timers.delete(target);
          return;
        }

        if (observed.has(target) || timers.has(target)) return;
        timers.set(target, window.setTimeout(function () {
          if (observed.has(target) || target.hidden || target.closest("[hidden]")) return;
          observed.add(target);
          timers.delete(target);
          capturePdpCommerceEvent("pdp_cta_impression", target, {
            cta_location: target.matches("[data-sticky-cart-button]") ? "sticky" : "main"
          });
        }, 500));
      });
    }, {threshold: [0.5]});

    document.querySelectorAll(
      ".pdp-bundle-selector__button, [data-sticky-cart-button]"
    ).forEach(function (target) {
      observer.observe(target);
    });
  }

  function publishPdpInteraction(interaction, target, data) {
    if (!isProductPage()) return;
    publishCustomerEvent(
      "dwk:pdp_interaction",
      Object.assign({interaction: interaction}, productContext(target), data || {})
    );
  }

  function startPerformanceTracking() {
    if (!isProductPage() || typeof PerformanceObserver !== "function") return;

    var metrics = {lcp_ms: null, cls: 0, inp_ms: null};
    var published = false;

    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        if (entries.length) metrics.lcp_ms = Math.round(entries[entries.length - 1].startTime);
      }).observe({type: "largest-contentful-paint", buffered: true});
    } catch (error) {}

    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!entry.hadRecentInput) metrics.cls += entry.value;
        });
      }).observe({type: "layout-shift", buffered: true});
    } catch (error) {}

    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.interactionId && (metrics.inp_ms == null || entry.duration > metrics.inp_ms)) {
            metrics.inp_ms = Math.round(entry.duration);
          }
        });
      }).observe({type: "event", buffered: true, durationThreshold: 40});
    } catch (error) {}

    function publishPerformance() {
      if (published) return;
      published = true;
      publishPdpInteraction("pdp_performance", document.body, {
        lcp_ms: metrics.lcp_ms,
        cls: Math.round(metrics.cls * 10000) / 10000,
        inp_ms: metrics.inp_ms
      });
    }

    window.addEventListener("pagehide", publishPerformance, {once: true});
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") publishPerformance();
    });
  }

  function startCommerceTracking() {
    if (commerceTrackingStarted) return;
    commerceTrackingStarted = true;

    document.addEventListener("click", function (event) {
      if (!isProductPage()) return;
      var target = event.target;
      if (!target || !target.closest) return;

      var addButton = target.closest(
        'product-form-component button[name="add"], product-form-component input[type="submit"]'
      );
      if (addButton) {
        var addComponent = addButton.closest("product-form-component");
        var isRecommendation = addComponent &&
          addComponent.classList.contains("quick-add__product-form-component");
        var quantityInput = addComponent && addComponent.querySelector('[name="quantity"]');
        var ctaLocation = addButton.dataset.dwkCtaLocationOverride || "main";
        publishPdpInteraction(
          isRecommendation
            ? "pdp_recommendation_add_to_cart_clicked"
            : "pdp_add_to_cart_clicked",
          addButton,
          {
            element: isRecommendation
              ? "recommendation_add_to_cart"
              : ctaLocation + "_add_to_cart",
            cta_location: isRecommendation ? "recommendation" : ctaLocation,
            quantity: quantityInput ? Number(quantityInput.value) || 1 : 1
          }
        );
        if (!isRecommendation) rememberPdpAddAttempt(addButton, ctaLocation);
        return;
      }

      var summary = target.closest("details > summary");
      if (summary) {
        var details = summary.parentElement;
        window.setTimeout(function () {
          if (!details.open) return;
          var label = (summary.innerText || summary.textContent || "").trim();
          publishPdpInteraction(
            /versand|liefer|umtausch|retour/i.test(label)
              ? "pdp_shipping_info_opened"
              : "pdp_details_opened",
            summary,
            {label: label, element: "details"}
          );
        }, 0);
        return;
      }

      var reviewControl = target.closest("a,button");
      if (reviewControl) {
        var reviewText = [
          reviewControl.innerText || reviewControl.textContent || "",
          reviewControl.className || "",
          reviewControl.id || "",
          reviewControl.getAttribute("href") || ""
        ].join(" ");
        if (/review|bewert|sterne|loox/i.test(reviewText)) {
          publishPdpInteraction("pdp_reviews_opened", reviewControl, {
            element: reviewControl.tagName.toLowerCase()
          });
          return;
        }
      }

      var recommendationLink = target.closest('a[href*="/products/"]');
      if (recommendationLink) {
        var recommendationUrl = new URL(recommendationLink.href, window.location.origin);
        if (recommendationUrl.pathname !== window.location.pathname) {
          publishPdpInteraction("pdp_recommendation_clicked", recommendationLink, {
            element: "product_link",
            label: recommendationUrl.pathname.split("/").filter(Boolean).pop()
          });
          return;
        }
      }

      var mediaControl = target.closest(
        "media-gallery [data-media-id], media-gallery button, media-gallery slideshow-controls"
      );
      if (mediaControl) {
        var mediaContainer = mediaControl.closest("[data-media-id]");
        publishPdpInteraction("pdp_gallery_interacted", mediaControl, {
          element: mediaControl.tagName.toLowerCase(),
          media_id: mediaContainer && mediaContainer.dataset
            ? mediaContainer.dataset.mediaId || null
            : null
        });
      }
    }, true);

    document.addEventListener("variant:selected", function (event) {
      var resource = event.detail && event.detail.resource || {};
      publishPdpInteraction("pdp_variant_selected", event.target, {
        variant_id: resource.id || null,
        element: "variant_picker"
      });
    });

    document.addEventListener("media:started-playing", function (event) {
      var resource = event.detail && event.detail.resource || {};
      publishPdpInteraction("pdp_video_played", event.target, {
        media_id: resource.id || null,
        media_type: resource.media_type || "video",
        element: "product_media"
      });
    });

    document.addEventListener("cart:update", function (event) {
      if (
        !pendingPdpAddAttempt ||
        !event.detail ||
        !event.detail.data ||
        event.detail.data.source !== "product-form-component"
      ) return;

      var sourceId = event.detail && event.detail.sourceId;
      if (sourceId && pendingPdpAddAttempt.variant_id &&
        String(sourceId) !== String(pendingPdpAddAttempt.variant_id)) return;

      var didError = Boolean(event.detail && event.detail.data && event.detail.data.didError);
      finishPdpAddAttempt(didError ? "failure" : "success", event.target, {
        error_type: didError ? "shopify_cart_update_error" : null
      });
    });

    window.addEventListener("cart:error", function (event) {
      var sourceId = event.detail && event.detail.sourceId;
      if (pendingPdpAddAttempt && (!sourceId || !pendingPdpAddAttempt.variant_id ||
        String(sourceId) === String(pendingPdpAddAttempt.variant_id))) {
        finishPdpAddAttempt("failure", event.target, {
          error_type: "shopify_cart_error"
        });
      }
      publishPdpInteraction("pdp_add_to_cart_failed", document.body, {
        error_type: "shopify_cart_error",
        element: "product_form"
      });
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", startPdpCtaImpressionTracking, {once: true});
    } else {
      startPdpCtaImpressionTracking();
    }

    startPerformanceTracking();
  }

  window.dwkPublishPdpExperimentExposure = function (experimentKey, variant, version) {
    if (!isProductPage()) return;
    publishCustomerEvent(
      "dwk:pdp_experiment_exposed",
      Object.assign(
        {
          experiment_key: experimentKey,
          experiment_version: version || "1",
          variant: variant
        },
        productContext(document.body)
      )
    );
  };

  window.dwkCapturePdpEvent = capturePdpCommerceEvent;

  document.addEventListener("visitorConsentCollected", syncPostHogConsent);
  startCommerceTracking();

  if (window.Shopify && Shopify.customerPrivacy) {
    syncPostHogConsent();
  } else if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures(
      [{name: "consent-tracking-api", version: "0.1"}],
      function (error) {
        if (!error) syncPostHogConsent();
      }
    );
  }
})();
